(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name cabinPerformanceComment.controller:CabinPerformanceCommentCtrl
	 *
	 * @description
	 *
	 */
	angular.module('cabinPerformanceComment').controller(
			'CabinPerformanceCommentCtrl', CabinPerformanceCommentCtrl);

	function CabinPerformanceCommentCtrl(CommonMasterData, $sce,
			CommonLogicService, crewScheduleService, CabinPerformanceCommentService, MessageService,EventManagerService,PopupManager, applicationConstants) {
		var vm = this;
		vm.ctrlName = 'CabinPerformanceCommentCtrl';
		vm.model = {
			searchPanelToggle : true,
			searchCriteria : {
				fromDate : null,
				toDate : null,
				crewType : null,
				crewName : null,
				crewId : null
			},
      commentList:null,
			masterList : {
				crewTypes : [],
				fromDateFormatInvalid : false,
				toDateFormatInvalid : false,
				fromDateAfterToDate : false,
				isToDateFutureDate : false
			},
      viewDetails:{
        fromDate : null,
        toDate : null,
        editPrivilege :false
      },
			initialSearchDone : false,
			reportDataURL : null,
			reportServerBaseUrl : null,
      searchOnGoing:false,
      editorMode: applicationConstants.EDITOR_STATUS.ADD,
      showRightPanel:false,
      selectedComment : null,
      generateReport:false,
      searchId:1

		};

		// toggle search
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		// submit search
		vm.submitSearch = function(params) {
			//searchCabinPerformanceComments(params);
      if(!vm.model.masterList.toDateFormatInvalid
        && !vm.model.masterList.fromDateFormatInvalid
        && !vm.model.masterList.isToDateFutureDate){
        searchCabinPerformanceCommentGrid();
      }

		};

    vm.printReport= function(){
      vm.model.searchId = vm.model.searchId +1;
      vm.model.generateReport = !vm.model.generateReport;
      searchCabinPerformanceComments(vm.model.searchCriteria);
    };

    vm.onRefresh = function () {
      searchCabinPerformanceCommentGrid();
    }


		function searchCabinPerformanceCommentGrid() {
      showLoader(true);
      vm.model.searchId = vm.model.searchId +1;
      searchCabinPerformanceComments(vm.model.searchCriteria);
      CabinPerformanceCommentService.searchCabinPerformanceReport(vm.model.searchCriteria);
      CabinPerformanceCommentService.getCabinPerformanceComment(
        function (commentList) {
          vm.model.commentList = commentList;
          vm.model.viewDetails.fromDate = vm.model.searchCriteria.fromDate;
          vm.model.viewDetails.toDate = vm.model.searchCriteria.toDate;
          vm.model.searchPanelToggle = false;
          showLoader(false);
          vm.model.searchOnGoing = false;
          vm.model.generateReport =false;
        },
        function (error) {
          MessageService.error(error);
          showLoader(false);
        }
      );

    }

    function showLoader(flag) {
      EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, {
        flag: flag,
        target: 'cabinPerformanceComment',
        animationName: 'crewing-loader'
      });
    }

		// on change search field
		vm.changeSearchField = function(searchParams, flag) {
			setDateValidationFlags();
			if (!vm.model.masterList.toDateFormatInvalid
					&& !vm.model.masterList.fromDateFormatInvalid
					&& !vm.model.masterList.isToDateFutureDate) {
				if (istoDateBeforeFromDate()) {
					vm.model.masterList.fromDateAfterToDate = true;
				} else {
					vm.model.masterList.fromDateAfterToDate = false;
				}
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
			}

			if (flag == 'crewType') {
				vm.model.searchCriteria.crewName = null;
				if (!!vm.model.searchCriteria.crewType
						&& !!vm.model.searchCriteria.crewType.crewTypeCode) {
					loadCrewList(vm.model.searchCriteria.crewType.crewTypeCode);
				} else {
					vm.model.masterList.crewList = [];
				}
			} else if (flag == 'crewName') {
				if (!!vm.model.searchCriteria.crewName) {
					vm.model.searchCriteria.crewId = vm.model.searchCriteria.crewName.crewId;
				}
			} else if (flag == 'crewId') {
				vm.model.searchCriteria.crewType = null;
				vm.model.searchCriteria.crewName = null;
				vm.model.masterList.crewList = [];
			}
		};

    vm.doAction = function(selectedRowData, flag){
      vm.model.showRightPanel =true;
      vm.model.selectedComment = CabinPerformanceCommentService.setSelectedComment(selectedRowData);

      if(flag == "log"){
        vm.model.editorMode = flag;
      }else{
        vm.model.editorMode = applicationConstants.EDITOR_STATUS.ADD;
      }
    };

    vm.submitComment = function(action, selectedItem){

      if(action == "add"){
        updateCabinFlightComment(selectedItem);
      }else if("delete"){
        vm.model.showRightPanel = false;
      }
    };

    function updateCabinFlightComment(params) {
      CabinPerformanceCommentService.setUpdateCabinPorformanceCommentData(params);
      CabinPerformanceCommentService.updateCabinPerformanceComment(
          function (commentList) {
            vm.model.showRightPanel =false;
            MessageService.success('Comment Successfully Saved.');
            searchCabinPerformanceCommentGrid();
          },
          function (error) {
            MessageService.error(error);
          }
        );

    }

    vm.closeRightPanel = function(){
      if(vm.model.recordChange){
        var confirmClose = {};
        confirmClose.title = "Confirm Close";
        confirmClose.messages = [];
        confirmClose.messages[0] = "Unsaved information will be loss.";
        confirmClose.messages[1] = "Do you want to close this?";
        PopupManager.openModal('CONFIRM_DIALOG', confirmClose, handelConfirmClose);
      }else{
        vm.model.showRightPanel = false;
        vm.model.recordChange = false;
      }
    };

    function handelConfirmClose(pass) {
      if(pass==="YES"){
        vm.model.showRightPanel = false;
        vm.model.recordChange = false;
      }
    }

		// load crew list
		function loadCrewList(crewType) {
			var load = function() {
				var param = {};
				param.crewType = crewType;
				param.active = true;
				CommonMasterData.loadCrewList(param, function(response) {
					vm.model.masterList.crewList = crewScheduleService
							.adaptCrewList(response);
				}, function() {
					console.log('Crew list retrieval error');
				});
			};
			load();
		}

		function setDateValidationFlags() {
			// if from date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
				vm.model.masterList.fromDateFormatInvalid = true;
			} else {
				vm.model.masterList.fromDateFormatInvalid = false;
			}

			// if to date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
				vm.model.masterList.toDateFormatInvalid = true;
				vm.model.masterList.isToDateFutureDate = false;
			} else {
				vm.model.masterList.toDateFormatInvalid = false;
				if (!!vm.model.searchCriteria.toDate) {
					vm.model.masterList.isToDateFutureDate = istoDateFutureDate();
				} else {
					vm.model.masterList.isToDateFutureDate = false;
				}
			}
		}

		function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
			return false;
		}

		// check from date and to date
		function istoDateBeforeFromDate() {
			return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
					.isBefore(
							moment(vm.model.searchCriteria.fromDate,
									"DD/MM/YYYY"));
		}
		;

		// check to date is a future date
		function istoDateFutureDate() {
			return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
					.isAfter(moment().toDate());
		}
		;

		// search Crew Water Consumption Report
		function searchCabinPerformanceComments(param) {
			vm.model.initialSearchDone = true;
			if (isValidSearchParams(param)) {
				vm.model.searchCriteria = param;
				vm.model.searchPanelToggle = false;
				var url = CommonLogicService.getReportUrl(
						'cabin_performance_comments.rptdesign',
						getSearchParamMap(param));
				vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
			}
		}

		// set search param map
		function getSearchParamMap(param) {
			var searchParamMap = {};
			searchParamMap["fromDate"] = param.fromDate;
			searchParamMap["toDate"] = param.toDate;
			if (!!param.crewId) {
				searchParamMap["crewId"] = param.crewId;
			}
			searchParamMap["searchId"] = vm.model.searchId;
			return searchParamMap;
		}

		function isValidSearchParams(params) {
			setDateValidationFlags();
			// if date invalid
			if (vm.model.masterList.toDateFormatInvalid
					|| vm.model.masterList.fromDateFormatInvalid
					|| vm.model.masterList.isToDateFutureDate) {
				return false;
			} else if (istoDateBeforeFromDate()) {
				vm.model.masterList.fromDateAfterToDate = true;
				return false;
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
				return true;
			}
		}

		( // load crew Types
		function loadCrewTypes() {
			CommonMasterData.getCrewTypeList(function(crewTypes) {
				vm.model.masterList.crewTypes = crewTypes;
			}, function() {
				console.log('Crew type retrieval error');
			});
		}

		)();


    ( // load crew Types
      function loadPrivilege() {
        CabinPerformanceCommentService.getCabinPerformanceEditPrivilege(function(editPrivilege) {
          vm.model.viewDetails.editPrivilege = editPrivilege;
        }, function() {

        });
      }

    )();

	}
}());
